import "../styles/notifications.css"
import AdminContainer from "../components/AdminContainer.jsx"
import { useState, useEffect } from "react"
import NotificationRow from "../components/componentsScreenNotifications/NotificationCard.jsx"
import { ShowNotificationsByUserId } from "../services/notificationService.js"
import SendNotificationPanelAdmin from "../components/componentsScreenNotifications/sendNotificationPanelAdmin.jsx"

export default function NotificationScreen(){

    const [pannelAdminShow, setPannelAdminShow] = useState(false)
    const [notifications, setNotifications] = useState([])
    const [count, setCount] = useState(false)
    const [notificationType, setNotificationType] = useState(0)

    useEffect(() => {
        const checkNotifications = async () => {
            let data = null
            if(notificationType == 0){
                data = await ShowNotificationsByUserId()
            }else{
                data = await ShowNotificationsByUserId(true)
            }
            
            if (!data) return
            setNotifications([...data].reverse())
        }
        checkNotifications()
    }, [count, notificationType])

    return(
        <div className="notifications-container">
            <h1 className="notifications-title">Notificaciones</h1>
            <div className="notifications-header">
                <div className="header-actions">
                    <AdminContainer rols={["admin"]}>
                        <div className="tab-buttons">
                            <button 
                                className={`tab-btn ${notificationType === 0 ? "tab-btn--active" : ""}`}
                                onClick={() => setNotificationType(0)} 
                                disabled={notificationType === 0}
                            >
                                Recibidas
                            </button>
                            <button 
                                className={`tab-btn ${notificationType === 1 ? "tab-btn--active" : ""}`}
                                onClick={() => setNotificationType(1)} 
                                disabled={notificationType === 1}
                            >
                                Enviadas
                            </button>
                        </div>
                        <button className="refresh-btn" onClick={() => setPannelAdminShow(!pannelAdminShow)}>
                            Enviar notificacion
                        </button>
                    </AdminContainer>
                    <button className="refresh-btn" onClick={() => setCount(!count)}>
                        ↻ Actualizar
                    </button>              
                </div>
                
            </div>
            {
                pannelAdminShow && (
                    <SendNotificationPanelAdmin clousePanel={() => setPannelAdminShow(!pannelAdminShow)}></SendNotificationPanelAdmin>
                )
            }
            {
                notifications.map((notification, index) => (<NotificationRow key={index} notification={notification} />))
            }
        </div>
    )
}
